import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import productCore from "../core/product.core";
import { ProductListRes } from "../types/product";

export default function useProductsGiftCard() {
  const { isReady, locale } = useRouter();

  return useQuery<ProductListRes>({
    queryKey: ["products", locale, "giftCard"],
    queryFn: async () => {
      try {
        const data = await productCore.getProducts(locale, "giftCard");
        return data;
      } catch (error) {
        console.error("Error fetching products:", error);
        throw error;
      }
    },
    enabled: isReady,
  });
}
